import { makeAutoObservable } from 'mobx';
import { makePersistable } from 'mobx-persist-store';

class Pages {
    services = [];
    testimonials = [];
    blogs = [];
    social_media = [];

    constructor() {
        makeAutoObservable(this);
        if (typeof window !== 'undefined') {
            // ✅ Safe: only runs in browser
            makePersistable(this, {
                name: 'pagesStore',
                properties: ['services', 'testimonials', 'blogs', 'social_media'],
                storage: window.localStorage
            });
        }
    }

    // Update or add a single key-value pair
    updateValue = (key, value) => {
        (this)[key] = value;
    }

    reset = () => {
        this.services = [];
        this.testimonials = [];
        this.blogs = [];
        this.social_media = [];
    }
}
const pages = new Pages();
export default pages;
